import { render, staticRenderFns } from "./IndexRatingStars.vue?vue&type=template&id=62368406"
import script from "./IndexRatingStars.vue?vue&type=script&lang=js"
export * from "./IndexRatingStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62368406')) {
      api.createRecord('62368406', component.options)
    } else {
      api.reload('62368406', component.options)
    }
    module.hot.accept("./IndexRatingStars.vue?vue&type=template&id=62368406", function () {
      api.rerender('62368406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/IndexRatingStars.vue"
export default component.exports